import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenService } from '../services/token.service';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const jwtToken = tokenService.getToken() ?? tokenService.getPreAuthToken();
  const entraToken = tokenService.getTokenEntra() || '';
  const router = inject(Router);

  if (jwtToken) {
    const bearer = `Bearer ${jwtToken}`;

    req = req.clone({
      setHeaders: {
        Authorization: bearer,
        'X-Entra-Token': entraToken,
      },
    });
  }
  
  const authPaths = ['/login', '/verify-twofa', '/SendAuthCode', '/RequestResetPassword', '/ResetPassword'];
  const isAuthRequest = authPaths.some((path) => req.url.includes(path));

  return next(req).pipe(
    catchError((err) => {
      if (err.status === 401 && !isAuthRequest) {
        router.navigateByUrl('/login');
      }
      return throwError(() => err);
    })
  );
};
